export const deClientPortalComparablesCategory = {
    titles: {
        yield_and_multiplier: 'Renditen und Multiplikatoren',
        rent: 'Mieten',
    },
    ratings: {},
    marketAreaValueTooltip: 'Vergleichswert: {{value}}',
    tabs: {
        market_area_value: 'Preis pro m²',
        market_value: 'Absoluter Preis',
        yield: 'Rendite',
        multiplier: 'Multiplikator',
        discount_rate: 'Liegenschaftszinssatz',
        monthly_rent: 'Miete pro Monat',
        yearly_rent: 'Miete pro Jahr',
    },
    units: {
        market_area_value: '€/m²',
        market_value: '€',
        yield: '%',
        multiplier: '',
        discount_rate: '%',
        monthly_rent: '€/m² pro Monat',
        yearly_rent: '€/m² pro Jahr',
    },
    chart: {
        emptyLabel: 'Keine Daten',
        generatedValuesTooltip:
            'Diese Werte wurden automatisch aus einer verwandten Datenreihe berechnet. (z.B. Rendite zu Multiplikator oder Monatsmiete zu Jahresmiete)',
        sourceDateWarning: 'Quelle älter als 12 Monate',
        relevantDataPoints_one: '{{count}} relevanter Datenpunkt',
        relevantDataPoints_other: '{{count}} relevante Datenpunkte',
        totalDataPoints: '{{count}} gesamt',
        unknownDataPointCount: 'Datenpunktanzahl unbekannt',
        unnamedDataSeries: 'Unbenannte Datenreihe',
    },
    referencePickerLabel: 'VERGLEICHSWERT',
    yieldOptions: {
        grossYield: 'Bruttorendite',
        grossInitialYield: 'Bruttoanfangsrendite',
    },
    multiplierOptions: {
        grossYieldMultiplier: 'Rohertragsmultiplikator',
        netYieldMultiplier: 'Reinertragsmultiplikator',
    },
    valueLabels: {
        absolute: 'Wert',
        average: 'Durchschnitt',
        minimum: 'Min',
        maximum: 'Max',
        median: 'Median',
        mode: 'Modalwert',
        uppermostQuartile: 'Oberstes Quartil',
        lowestQuartile: 'Unterstes Quartil',
        veryGoodResidentialValue: 'Sehr guter Wohnwert',
        goodResidentialValue: 'Guter Wohnwert',
        mediumResidentialValue: 'Mittlerer Wohnwert',
        badResidentialValue: 'Einfacher Wohnwert',
        veryGoodUsageValue: 'Sehr guter Nutzungswert',
        goodUsageValue: 'Guter Nutzungswert',
        mediumUsageValue: 'Mittlerer Nutzungswert',
        badUsageValue: 'Einfacher Nutzungswert',
    },
    observationTime: {
        date: 'Stichtag {{date}}',
        range: 'Zeitspanne {{range}}',
        unknownRange: 'unbekannt',
    },
    retrievedOn: 'Abruf am {{date}}',
    sourceDate: {
        year: 'Quelle von {{date}}',
        dated: 'Quelle vom {{date}}',
    },
}
